var map = {
	"./HTMLCSS.png": 7846,
	"./HTMLCSS2.png": 8342,
	"./HTMLCSS3.png": 4996,
	"./HTMLCSS4.png": 4082,
	"./HTMLCSS5.png": 2293,
	"./HTMLCSS6.png": 4529,
	"./JS.png": 7332,
	"./JS1.1.png": 7149,
	"./JS1.2.png": 1372,
	"./JS2-1.png": 28,
	"./JS2-2.png": 742,
	"./JS2-3.png": 1482,
	"./JS2.png": 8966,
	"./JS3.png": 9797,
	"./MitraSoft.png": 9733,
	"./MitraSoft1.png": 5266,
	"./MitraSoft2.png": 3958,
	"./MitraSoft3.png": 9211,
	"./Pharmacy.png": 5335,
	"./Pharmacy2.png": 7479,
	"./Pharmacy3.png": 2148,
	"./Pharmacy4.png": 3269,
	"./Pharmacy5.png": 3690,
	"./React1-2.png": 5089,
	"./React1-3.png": 6491,
	"./React1-4.png": 4487,
	"./React1-5.png": 4170,
	"./React1.png": 8200,
	"./React2.png": 7272,
	"./React3-0.png": 1902,
	"./React3-1.png": 1498,
	"./React3.png": 5445,
	"./React4-1.png": 7551,
	"./React4-2.png": 4977,
	"./React4-3.png": 3639,
	"./React4-4.png": 9734,
	"./React4-5.png": 9776,
	"./React4-6.png": 9202,
	"./React4-7.png": 279,
	"./React4.png": 6668,
	"./React5-1.png": 6424,
	"./React5-2.png": 4098,
	"./React5.png": 3416,
	"./adaptiv.png": 9811,
	"./adaptiv1.png": 9672,
	"./adaptiv2.png": 4648,
	"./adaptiv3.png": 84,
	"./adaptiv4.png": 9459,
	"./adaptiv5.png": 645,
	"./adaptiv6.png": 3158,
	"./dashboard1.png": 2374,
	"./dashboard2.png": 8458,
	"./dashboard3.png": 5902,
	"./dashboard4.png": 187,
	"./dashboard5.png": 3780,
	"./game1-2.png": 4786,
	"./game1-3.png": 6724,
	"./game1.png": 3074,
	"./game2.png": 1872,
	"./port1.png": 8945,
	"./port2.png": 1186,
	"./port3.png": 3441,
	"./port4.png": 4124,
	"./port5.png": 3493,
	"./port6.png": 8613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1460;